<template>
  <MUIDialog
    class="mui-dialog--welcome"
    :acceptItem="acceptItem"
    :dismissItem="dismissItem"
    :displayType="displayType"
    :title="title"
    ref="dialog">
    <div>
      <p>Cookmark was created by a husband and wife team inspired to help organize others organize their cooking lives. Thanks for being part of this journey that starts with an app and ends up... who knows where 🤔</p>
      <p>We'd like to thank our friends and family for their support while we work this out. Thank you to our beta testers for their ongoing support and feedback.</p>
      <p>Want to help us out? We'd love for you to buy us a coffee.</p>
      <p>☕️☕️☕️</p>
    </div>
  </MUIDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  MUIDialog
} from '../components'
import {
  errorMessages
} from '@/utils'

import { APP } from '../config'

export default {
  components: {
    MUIDialog
  },
  props: [
    'placeholder'
  ],
  computed: {
    ...mapGetters([
      'isSizeClassRegular'
    ]),
    error () {
      return this.errors.length > 0 && errorMessages().feedback
    }
  },
  data () {
    return {
      acceptItem: {
        name: 'Buy us a coffee',
        fn: () => {
          this.$refs.dialog.close()
          window.open('https://www.buymeacoffee.com/luckystudios')
        }
      },
      dismissItem: {
        name: 'Not right now'
      },
      displayType: APP,
      title: 'Welcome'
    }
  }
}
</script>

<style lang="sass" scope>
.mui-dialog--feedback
  .device__viewport-class--regular &
    width: 360px
  .mui-dialog__body
    padding: 0
  .input--placeholder, textarea
    padding: 24px
    line-height: 30px
  .input--placeholder
    pointer-events: none
    position: absolute
</style>



// WEBPACK FOOTER //
// src/views/Credits.vue